/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { withRouter } from "react-router";
import {bindActionCreators} from 'redux';

import HomePage from './HomePage';
import Footer from '../components/Footer';
import LandingPage from './LandingPage'

import NotFoundPage from '../components/NotFoundPage';

import { ToastContainer, style } from 'react-toastify';
import away from 'away';
import * as settings from '../constants/settings';
import * as homeActions from '../actions/homeActions'
import PrivateRoute from '../components/PrivateRoute';
import  PayAndConfirmPage  from './PayAndConfirmPage';
import { userActions } from '../actions/userActions';
import ConfirmationPage from './ConfirmationPage';

import GenericContent from './GenericContent';
import getPortalLocData from '../config/loc';
import ReactGA from 'react-ga';


const timer = away(settings.TIMEOUT_MILLISECONDS);



style({
  colorSuccess: "#59BA53"
});


class App extends React.Component {
  constructor(props) {
    super(props);
    this.props.history.listen((location) => {  
      if (window.ga) {
        window.ga('send', 'pageview', location.pathname);
      }
    });

    this.state = {
      cookiesAccepted: false,
    };
  }



  componentDidMount(){
    const ele = document.getElementById('ipl-progress-indicator');
    if(ele){
      setTimeout(() => {
        ele.classList.add('available');
        setTimeout(() => {
          ele.outerHTML = '';
        }, 2000);
      }, 1000);
    }

    if (!document.title) {
      document.title = getPortalLocData().title;
    }
    window.addEventListener('CookiebotOnAccept', () => {
      this.setState({ cookiesAccepted: true });
      console.warn('CookiebotOnAccept !!');

      ReactGA.initialize("UA-16503189-5");
      ReactGA.pageview(window.location.hash);
    });
  }

  componentWillUnmount() {
    window.removeEventListener('CookiebotOnAccept', () => {
      this.setState({ cookiesAccepted: false });
    });}
  
  render() {
    let { pathname } = this.props.history.location;

    return (
      <div className={"root " + getPortalLocData().name }>

        {getPortalLocData().name === "airport" &&
        
        <div>
            <div className="topbar d-none d-lg-block">
              <div className="container">
                  <div className="row g-0">
                      <div className="col-6 col-sm-8">
                          <a className="d-none d-sm-inline" href="mailto:info@longtermparking.ie">
                            <i className="fa fa-envelope"></i> info@longtermparking.ie
                          </a>
                      </div>

                      <div className="col-6 col-sm-4 text-end ">
                          <div className="social-links">
                              <p className="m-0 text-white">Follow us on - </p>
                              <a targetname="_blank" title="Facebook" href="https://www.facebook.com/">
                                  <i className="fa fa-facebook-f bxl-facebook"></i>
                              </a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        }
          <Switch>
            <PrivateRoute exact path="/"
                          history={this.props.history}
                          location={this.props.location}
                          authentication={this.props.authentication}
                          component={HomePage} />
            <PrivateRoute exact path="/landing"
                          history={this.props.history}
                          location={this.props.location}
                          authentication={this.props.authentication}
                          component={LandingPage} />
            <PrivateRoute exact path="/bookingdetail"
                          history={this.props.history}
                          location={this.props.location}
                          authentication={this.props.authentication}
                          loginActions={this.props.userActions}
                          component={PayAndConfirmPage} />
            <PrivateRoute exact path="/confirmation"
                          history={this.props.history}
                          location={this.props.location}
                          authentication={this.props.authentication}
                          loginActions={this.props.userActions}
                          component={ConfirmationPage} />

            <PrivateRoute
                          path="/:pathname" 
                          history={this.props.history}
                          location={this.props.location}
                          authentication={this.props.authentication}
                          loginActions={this.props.userActions}
                          component={GenericContent}/>

            <PrivateRoute component={NotFoundPage} />
          </Switch>
          <ToastContainer
                autoClose={8000}
                pauseOnHover={true}
                hideProgressBar={true} />

        {getPortalLocData().name === "airport" &&
          <Footer/>
        }
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.element,
  location: PropTypes.object,
  history: PropTypes.object,
  homeActions: PropTypes.object,
  userActions: PropTypes.object,
  authentication:PropTypes.object
};

function mapStateToProps(state) {
  return {
      authentication:state.authentication
  };
}



function mapDispatchToProps(dispatch) {
  return {
    homeActions:bindActionCreators(homeActions,dispatch),
    userActions:bindActionCreators(userActions,dispatch)

  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(App));


// WEBPACK FOOTER //
// ./src/containers/App.jsx